ForgotPasswordEmailConfirmationController.$inject = ['$scope', '$state'];

// eslint-disable-next-line @treasury/filename-match-export
export default function ForgotPasswordEmailConfirmationController($scope, $state) {
    $scope.returnToLogin = function () {
        $state.go('login');
    };
}
